import React from 'react'
import { useHistory } from 'react-router-dom'

export default function FilterOption({ item, mostrarEmDispositivos }) {
  const history = useHistory()

  const handleClick = async () => {
    await mostrarEmDispositivos(item.clickParam)
    history.push('/veye/dispositivos')
  }

  return (
    <li>
      <div
        className="drop-acoes-menu item-drop-acoes-hover"
        onClick={handleClick}
      >
        <span className="menu-opcoes-sub-label fonte-cor-1">{item.label}</span>
      </div>
      <div className="menu-opcoes-divisora campo-select-divisor-cor-1" />
    </li>
  )
}
